import { CatalogItem } from 'core/domains/catalog';
import { getItemBadges } from '../../helpers';
import { getValueTag } from 'ui/containers/ContentBuilder/widgets/utilities/tag';
import { search } from 'core/use-cases';
import { SEARCH_BAR, SEARCH_PAGE, generateItemListName } from '../../helpers/generateItemListName';
import type { ConsumerPrice, ResellerPrice } from 'ui/components';
import type { RootState } from 'core/store';
import type { TViewItemList } from '../../@types';

export const viewItemList = ({ payload, type, meta }: any, prevState: RootState) => {
  const isSearchBar = type === search.actions.searchFetch.success.type;
  const isSearchPage = !isSearchBar && window.location.search.includes('?q=');
  const itemListName = generateItemListName(isSearchPage, isSearchBar, payload);

  const items = payload?.data?.map((item: CatalogItem, index: number) => {
    return {
      item_id: item.productCode,
      item_name: item.name,
      affiliation: item.tags.length ? 'promocao' : 'padrao',
      discount: getValueTag(
        item.priceWrapper?.resellerPrice as unknown as ResellerPrice,
        item.priceWrapper?.consumerPrice as unknown as ConsumerPrice,
        true,
      ),
      index: index + 1,
      item_brand: item.brand,
      item_category: item.category,
      price: item.priceWrapper?.resellerPrice.price,
      quantity: 1,
      cd_item_tag: getItemBadges(item.tags, prevState),
      item_list_name: itemListName,
    };
  });

  const itemList = {
    event: 'view_item_list',
    ecommerce: {
      item_list_name: itemListName,
      items,
    },
  };

  const events: TViewItemList = items.length ? [itemList] : [];

  if (isSearchPage) {
    events.push({
      event_parameters: {
        cd_tipo_busca: SEARCH_PAGE,
        ...(items.length === 0 && { cd_error_message: 'empty-search' }),
      },
    });
  }

  if (isSearchBar) {
    const term = meta?.payload;
    events.push({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'view_search_results',
        search_term: term,
        cd_tipo_busca: SEARCH_BAR,
        ...(items.length === 0 && { cd_error_message: 'empty-search' }),
      },
    });
  }

  return events;
};
